import { Suspense, useEffect } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./scss/style.scss";
import { useReactiveVar } from "@apollo/client";
import Loading from "./components/Loading";
import { AuthProvider } from "./contexts/auth-context";
import { NETWORK_STATE, setNetworkState } from "./graphql/policies/network";
import { setTerritoryJSONCB } from "./graphql/policies/search";
import StatusCheck from "./layout/Components/StatusCheck";
import routes from "./routes/routes";
import { fiveDigitRand } from "./tools/random";

const router = createBrowserRouter(routes);

const App = () => {
  const networkState = useReactiveVar(setNetworkState);
  useEffect(() => {
    // Set some internals on startup
    setTerritoryJSONCB(fiveDigitRand());
  }, []);

  if (networkState === NETWORK_STATE.ERROR) {
    return <>Network Error</>;
  }

  return (
    <Suspense fallback={<Loading />}>
      <AuthProvider>
        <StatusCheck />
        <RouterProvider router={router}></RouterProvider>
      </AuthProvider>
    </Suspense>
  );
};

export default App;
